import { useContext } from 'react';
import PaymentRequiredView from '../views/PaymentRequiredView';
import { AppContext } from '@rabbit/app-context';

export default function PaymentWrapper(props: { children: React.ReactNode }) {
  const { tenantInfo } = useContext(AppContext);

  if (tenantInfo?.payment_deadline) {
    if (Date.now() > new Date(tenantInfo.payment_deadline).getTime()) {
      return <PaymentRequiredView />;
    } else {
      return <>{props.children}</>;
    }
  } else {
    return <>{props.children}</>;
  }
}
